module.exports = __webpack_public_path__ + "img/cpu.cc8386ea.svg";